module.exports = __webpack_public_path__ + "static/media/down.142d31ad.svg";